import { apiClient } from "@/lib/api-client";
import type {
  CouponValidationDto,
  CouponRedemptionDto,
} from "../dtos/coupon.dto";

export async function validateCoupon(
  code: string,
  organizationId: string,
  planId?: string,
): Promise<CouponValidationDto> {
  const { data } = await apiClient.get<CouponValidationDto>(
    "/coupon/validate",
    { params: { code, organizationId, planId } },
  );
  return data;
}

export async function redeemCoupon(
  code: string,
  organizationId: string,
): Promise<CouponRedemptionDto> {
  const { data } = await apiClient.post<CouponRedemptionDto>(
    "/coupon/redeem",
    { code, organizationId },
  );
  return data;
}
